export const ROLE_CONFIG = {
  locate2u: {
    label: 'Locate2u',
    operations: ['Create', 'Scheduled', 'Complete', 'Failed', 'SAP_SO', 'Exchange', 'Pickup'],
    defaultOperation: 'Create',
  },
  coco: {
    label: 'Coco Republic',
    operations: ['Create', 'Scheduled', 'Complete', 'Failed'],
    defaultOperation: 'Scheduled',
  },
  winnings: {
    label: 'Winnings',
    operations: ['SAP_SO', 'Exchange', 'Pickup'],
    defaultOperation: 'SAP_SO',
  },
};

export const DEFAULT_ROLE = 'locate2u';

export function getRoleConfig(role) {
  return ROLE_CONFIG[role] || ROLE_CONFIG[DEFAULT_ROLE];
}
